export default __webpack_public_path__ + "static/media/add.f77ef11d.svg";